'use client';

import { AttendanceCheckPage } from 'app/(appHeader)/quest/attendance-check/[yearMonth]/AttendanceCheckPage';

export default function Page() {
  return (
    <>
      <title>출석체크 | 디리토</title>
      <AttendanceCheckPage />
    </>
  );
}
